import _ from 'lodash'
import { LabelOf, createEnum } from '../utils/enumArray'

export interface ModalOptions {
  visible: boolean
  confirmLoading: boolean
}
export const InitialModalOptions: ModalOptions = {
  visible: false,
  confirmLoading: false,
}

export const EMPTY_LIST = []

export const InitialPagenationOption = {
  pageNo: 1,
  pageSize: 5,
  totalCount: 100,
}

// 签收凭证
export const signVoucherStateDict = {
  '1': '审核中',
  '2': '驳回',
  '3': '已确认',
  '4': '待上传',
}

export type SignVoucherState = keyof typeof signVoucherStateDict

type MapDict = {
  [key: string]: {
    name: string
    numstr: string
    [key: string]: any
  }
}

// 对账状态
export const accountStatusDict = {
  不可对账: {
    name: '不可对账',
    numstr: '1',
    detailColor: 'black',
  },
  可对账: {
    name: '可对账',
    numstr: '2',
    detailColor: 'orange',
  },
  对账中: {
    name: '对账中',
    numstr: '3',
    detailColor: 'orange',
  },
  对账完成: {
    name: '对账完成',
    numstr: '4',
    detailColor: 'black',
  },
  驳回待修改: {
    name: '驳回待修改',
    numstr: '5',
    detailColor: 'red',
  },
}
export type AccountStatusKey = keyof typeof accountStatusDict
export const accountStatusDictInvert = _.mapKeys(
  accountStatusDict,
  (o) => o.numstr,
)
export const accountStateList = _.map(accountStatusDict, (value) => {
  return { code: value.numstr, name: value.name, id: value.numstr }
})

// 供应商开票
export const openInvoiceStateDict = {
  审核中: {
    name: '审核中',
    numstr: '1',
  },
  暂存: {
    name: '暂存',
    numstr: '2',
  },
  已开票: {
    name: '已开票',
    numstr: '3',
  },
  驳回: {
    name: '驳回',
    numstr: '4',
  },
  未开票: {
    name: '未开票',
    numstr: '5',
  },
}
export type openInvoiceStateKey = keyof typeof openInvoiceStateDict
export const openInvoiceStateDictInvert = _.mapKeys(
  openInvoiceStateDict,
  (o) => o.numstr,
)

// 回款状态，对账单专用，！！！
export const returnMoneyStatedict = {
  未回款: {
    name: '未完成',
    numstr: '0',
  },
  部分回款: {
    name: '未完成',
    numstr: '1',
  },
  全部回款: {
    name: '已完成',
    numstr: '2',
  },
}
export const returnMoneyStatedictInvert = _.mapKeys(
  returnMoneyStatedict,
  (o) => o.numstr,
)

export const expressType = '25'

export type accountOpenInvoiceStateKey = keyof typeof openInvoiceStateDict
export const accountOpenInvoiceStateDictInvert = _.mapKeys(
  openInvoiceStateDict,
  (o) => o.numstr,
)

export const paymentStatusDict = {
  不可付款: {
    name: '不可付款',
    numstr: '1',
  },
  待申请: {
    name: '待申请',
    numstr: '2',
  },
  部分付款: {
    name: '部分付款',
    numstr: '3',
  },
  付款完成: {
    name: '付款完成',
    numstr: '4',
  },
  线下付款: {
    name: '线下付款',
    numstr: '5',
  },
  手动付款: {
    name: '手动付款',
    numstr: '33',
  },
  付款中: {
    name: '付款中',
    numstr: '6',
  },
}
export type paymentStatusKey = keyof typeof paymentStatusDict
export const paymentStatusDictInvert = _.mapKeys(
  paymentStatusDict,
  (o) => o.numstr,
)
export function convertDictToSearchList(dict: MapDict) {
  return _.values(dict).map((item) => {
    return {
      code: item.numstr,
      name: item.name,
      id: item.numstr,
    }
  })
}

// 物料提交
// 图片关联关系都是这两种状态
export const pictureRelevanceDict = {
  已关联: {
    name: '已关联',
    numstr: '1',
  },
  未关联: {
    name: '未关联',
    numstr: '2',
  },
}

// 物料扩展属性
export const extendedAttributeDict = {
  已补充: {
    name: '已补充',
    numstr: '1',
  },
  未补充: {
    name: '未补充',
    numstr: '2',
  },
  无需填写: {
    name: '无需填写',
    numstr: '0',
  },
}

// 订单报备类型
export const fillingReportDict = {
  商品报备: {
    name: '商品报备',
    numstr: '1',
  },
  客户订单报备: {
    name: '客户订单报备',
    numstr: '2',
  },
}
// 品牌审核状态
export const brandCheckDict = {
  审核中: {
    name: '审核中',
    numstr: '1',
  },
  驳回: {
    name: '驳回',
    numstr: '2',
  },
}

export type fillingReportKey = keyof typeof fillingReportDict
export const fillingReportDictInvert = _.mapKeys(
  fillingReportDict,
  (o) => o.numstr,
)

const returnStateList = [
  {
    label: '待审核',
    value: '1',
  },
  {
    label: '退货中',
    value: '2',
  },
  {
    label: '已退货',
    value: '3',
    displayText: '退货完成',
  },
  {
    label: '已拒绝',
    value: '4',
  },
] as const

export type ReturnStateLabel = LabelOf<typeof returnStateList>
// 退货单状态
export const returnStateEnum = createEnum(returnStateList)
import _ from 'lodash'
import { LabelOf, createEnum } from '../utils/enumArray'

export interface ModalOptions {
  visible: boolean
  confirmLoading: boolean
}
export const InitialModalOptions: ModalOptions = {
  visible: false,
  confirmLoading: false,
}

export const EMPTY_LIST = []

export const InitialPagenationOption = {
  pageNo: 1,
  pageSize: 5,
  totalCount: 100,
}

// 签收凭证
export const signVoucherStateDict = {
  '1': '审核中',
  '2': '驳回',
  '3': '已确认',
  '4': '待上传',
}

export type SignVoucherState = keyof typeof signVoucherStateDict

type MapDict = {
  [key: string]: {
    name: string
    numstr: string
    [key: string]: any
  }
}

// 对账状态
export const accountStatusDict = {
  不可对账: {
    name: '不可对账',
    numstr: '1',
    detailColor: 'black',
  },
  可对账: {
    name: '可对账',
    numstr: '2',
    detailColor: 'orange',
  },
  对账中: {
    name: '对账中',
    numstr: '3',
    detailColor: 'orange',
  },
  对账完成: {
    name: '对账完成',
    numstr: '4',
    detailColor: 'black',
  },
  驳回待修改: {
    name: '驳回待修改',
    numstr: '5',
    detailColor: 'red',
  },
}
export type AccountStatusKey = keyof typeof accountStatusDict
export const accountStatusDictInvert = _.mapKeys(
  accountStatusDict,
  (o) => o.numstr,
)
export const accountStateList = _.map(accountStatusDict, (value) => {
  return { code: value.numstr, name: value.name, id: value.numstr }
})

// 供应商开票
export const openInvoiceStateDict = {
  审核中: {
    name: '审核中',
    numstr: '1',
  },
  暂存: {
    name: '暂存',
    numstr: '2',
  },
  已开票: {
    name: '已开票',
    numstr: '3',
  },
  驳回: {
    name: '驳回',
    numstr: '4',
  },
  未开票: {
    name: '未开票',
    numstr: '5',
  },
}
export type openInvoiceStateKey = keyof typeof openInvoiceStateDict
export const openInvoiceStateDictInvert = _.mapKeys(
  openInvoiceStateDict,
  (o) => o.numstr,
)

// 回款状态，对账单专用，！！！
export const returnMoneyStatedict = {
  未回款: {
    name: '未完成',
    numstr: '0',
  },
  部分回款: {
    name: '未完成',
    numstr: '1',
  },
  全部回款: {
    name: '已完成',
    numstr: '2',
  },
}
export const returnMoneyStatedictInvert = _.mapKeys(
  returnMoneyStatedict,
  (o) => o.numstr,
)

export const expressType = '25'

export type accountOpenInvoiceStateKey = keyof typeof openInvoiceStateDict
export const accountOpenInvoiceStateDictInvert = _.mapKeys(
  openInvoiceStateDict,
  (o) => o.numstr,
)

export const paymentStatusDict = {
  不可付款: {
    name: '不可付款',
    numstr: '1',
  },
  待申请: {
    name: '待申请',
    numstr: '2',
  },
  部分付款: {
    name: '部分付款',
    numstr: '3',
  },
  付款完成: {
    name: '付款完成',
    numstr: '4',
  },
  线下付款: {
    name: '线下付款',
    numstr: '5',
  },
  手动付款: {
    name: '手动付款',
    numstr: '33',
  },
  付款中: {
    name: '付款中',
    numstr: '6',
  },
}
export type paymentStatusKey = keyof typeof paymentStatusDict
export const paymentStatusDictInvert = _.mapKeys(
  paymentStatusDict,
  (o) => o.numstr,
)
export function convertDictToSearchList(dict: MapDict) {
  return _.values(dict).map((item) => {
    return {
      code: item.numstr,
      name: item.name,
      id: item.numstr,
    }
  })
}

// 物料提交
// 图片关联关系都是这两种状态
export const pictureRelevanceDict = {
  已关联: {
    name: '已关联',
    numstr: '1',
  },
  未关联: {
    name: '未关联',
    numstr: '2',
  },
}

// 物料扩展属性
export const extendedAttributeDict = {
  已补充: {
    name: '已补充',
    numstr: '1',
  },
  未补充: {
    name: '未补充',
    numstr: '2',
  },
  无需填写: {
    name: '无需填写',
    numstr: '0',
  },
}

// 订单报备类型
export const fillingReportDict = {
  商品报备: {
    name: '商品报备',
    numstr: '1',
  },
  客户订单报备: {
    name: '客户订单报备',
    numstr: '2',
  },
}
// 品牌审核状态
export const brandCheckDict = {
  审核中: {
    name: '审核中',
    numstr: '1',
  },
  驳回: {
    name: '驳回',
    numstr: '2',
  },
}

export type fillingReportKey = keyof typeof fillingReportDict
export const fillingReportDictInvert = _.mapKeys(
  fillingReportDict,
  (o) => o.numstr,
)

const returnStateList = [
  {
    label: '待审核',
    value: '1',
  },
  {
    label: '退货中',
    value: '2',
  },
  {
    label: '已退货',
    value: '3',
    displayText: '退货完成',
  },
  {
    label: '已拒绝',
    value: '4',
  },
] as const

export type ReturnStateLabel = LabelOf<typeof returnStateList>
// 退货单状态
export const returnStateEnum = createEnum(returnStateList)
